// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1HI67","title":"AfterFrontImage_title__1ldZt"};